

export default class SortIndexRequest  {
	Id: number = 0;
	SortIndex: number = 0;
	constructor(obj?: Partial<SortIndexRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
